<style lang="scss" scoped>
.el-header {
  background-color: #264f78;
  // padding: 0 0 0 190px;
  height: 60px !important;
  min-width: 1200px;
  padding: 0;
}
.contents {
  width: 1200px;
  margin: 0 auto;
  display: grid;
  // grid-template-columns: repeat(3, 1fr); // 三个重复的column，宽度，和下面可以混写
  grid-template-columns: 1fr 100px 100px 100px; // 可以写好多个，fr表示可用空间的一等分
  grid-gap: 10px; // 设置column之间的间隔
  grid-auto-rows: minmax(60px, auto); // 不支持百分比，设置row的最小和最大高
  color: white;
  .logo {
    // line-height: 60px;
    height: 60px;
    // display: inline-block;
    display: flex;
    flex-direction: column;
    justify-content: center;
    img {
      width: 100%;
      line-height: 0;
    }
    p {
      margin: 2px;
      font-size: 12px;
      font-style: normal;
      line-height: 12px;
    }
  }
  .deviceTest {
    line-height: 60px;
    font-weight: bold;
    &:hover {
      cursor: pointer;
    }
  }
  .title {
    line-height: 60px;
    text-align: left;
    font-size: 24px;
    font-weight: bold;
  }
  .support,
  .resetpwd,
  .logout {
    line-height: 60px;
    font-weight: bold;
    img {
      transform: translateX(-5px) translateY(2px);
    }
    &:hover {
      cursor: pointer;
    }
  }
}
.helpWrapper {
  display: grid;
  grid-template-columns: 100px 1fr;
  .label {
    margin: 0;
  }
  .contact {
    text-align: left;
    grid-column-start: 2;
    grid-column-end: 3;
    display: grid;
    grid-template-columns: 140px 1fr;
  }
}
</style>
<template>
  <el-header>
    <!-- <slot name="headerContent"></slot> -->
    <div class="contents">
      <!-- <div class="logo">
        <img src="../assets/images/b-logo.png" alt>
        <p>官方授权合作方</p>
      </div>-->
      <span class="title"> {{typeHash === '#normal' ? '编玩边学在线考试平台' : ' 蓝桥杯在线考试平台'}}</span>
      <!-- <span @click="handleCheckDevice" class="deviceTest">设备检测</span> -->
      <div >
          <span v-if="!myExam.is_hand && (new Date(myExam.end_at) > new Date(serverTime))" class="support" @click="handleTechSup">
        <img src="../assets/images/tech-sup.png" alt>技术支持
          </span>
      </div>
      <template v-if="!isResetPwd">
       <span  @click="handleEditPwd" class="resetpwd" v-if="myExam.match_category !== 2 && myExam.match_category !== 3">
        <img src="../assets/images/password.png" alt>修改密码
      </span>
      <span @click="handleLogout" class="logout">退出登录</span>
      </template>

    </div>
    <el-dialog title="技术支持" :visible.sync="dialogVisible">
      <div class="helpWrapper">
        <p class="label">我需要帮助:</p>
        <el-input type="textarea" :rows="6" placeholder="请输入您的问题" v-model="techProblem"></el-input>

<!--        <div class="contact">-->
<!--          <p class="pleaseContact">也可以联系技术老师: </p>-->
<!--          <div>-->
<!--            <p >方老师   13713983984</p>-->
<!--            <p >李老师   13502867951</p>-->
<!--            <p >刘老师   13267130254</p>-->
<!--            <p >蒋老师   13113012566</p>-->
<!--          </div>-->

<!--        </div>-->

      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmitProblem">确 定</el-button>
      </span>
    </el-dialog>
    <edit-password :dialogVisible.sync="pwdDialogVisible"></edit-password>
  </el-header>
</template>
<script>
import {
 postTechSup, getMyExam, postLogout, getServerTime,
} from '@/services/getData';
import {
 AUTHORITY, EXAMINEE, MYEXAM, SERVERTIME,
} from '@/store/types';
import { mapMutations, mapState } from 'vuex';
import EditPassword from '@/views/user/EditPassword.vue';

export default {
  name: 'BaseNav',
  componentName: 'BaseNavMyExam',
  data() {
    return {
      dialogVisible: false,
      techProblem: '',
      pwdDialogVisible: false,
      serverTimer: null,
      isResetPwd: this.$route.path.match(/^\/user\/reset(p|P)assword/),
      typeHash: sessionStorage.getItem('hash') || this.$route.hash,
    };
  },
  methods: {
    ...mapMutations({
      setAuthority: AUTHORITY,
      setExaminee: EXAMINEE,
      setMyExam: MYEXAM,
      setServerTime: SERVERTIME,
    }),
    handleEditPwd() {
      // this.$router.push('/user/editPassword');
      this.pwdDialogVisible = true;
    },
    // handleCheckDevice() {
    //   this.$router.push('/user/deviceTest/1');
    // },
    handleTechSup() {
      this.dialogVisible = true;
    },
    handleSubmitProblem() {
      postTechSup(this.examinee.examination_examinee_id, {
        description: this.techProblem,
      })
        .then((resp) => {
          this.$message.success('问题提交成功');
          this.dialogVisible = false;
          this.techProblem = '';
        })
        .catch((err) => {
          if (err && err.status === 422) {
                this.$message.error(err.data.message);
              } else {
                this.$message.error(typeof err === 'string' ? err : '操作失败');
              }
          console.log(err);
        });
    },
    getMyExam() {
      const adminTicket = this.authority && this.authority.admissionTicket;
      getMyExam(adminTicket)
        .then((resp) => {
          this.setMyExam(resp);
          this.setExaminee({
            examination_examinee_id: resp.id,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleLogout() {
      this.$confirm('确定要退出登录吗？')
        .then(() => {
          postLogout()
            .then(() => {
              localStorage.clear();
              location.href = '/login';
            })
            .catch((err) => {
              this.$message.error('退出登录失败');
            });
        })
        .catch((err) => {});
    },
    fetchServerTime() {
      getServerTime()
        .then((resp) => {
          console.log(resp);
          this.setServerTime(new Date(resp));
          this.serverTimer = setInterval(() => {
            // 根据服务器时间设置定时器
            this.setServerTime(new Date(this.serverTime.valueOf() + 1000));
          }, 1000);
        })
        .catch((err) => {});
    },
  },
  components: {
    EditPassword,
  },
  created() {
    if (!this.authority) {
      const ls = localStorage.getItem('authority');
      this.setAuthority(JSON.parse(ls));
    }
    this.fetchServerTime();
    this.$on('show-tech-sup', (e) => {
      console.log(e, 'show-tech-sup');
      this.dialogVisible = true;
    });
  },
  mounted() {
    console.log(this.$route.path);
    if (!this.isResetPwd) {
      this.getMyExam();
    }
  },
  props: {
    status: {
      type: String,
    },
  },
  watch: {},
  beforeDestroy() {
    window.clearInterval(this.serverTimer);
    this.serverTimer = null;
  },
  computed: {
    ...mapState({
      authority: 'authority',
      examinee: 'examinee',
      currentUser: 'currentUser',
      myExam: 'myExam',
      serverTime: 'serverTime',
    }),
  },
};
</script>
